import React from 'react';
import { Modal } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';

interface ConfirmPatientModalProps {
    patientName: string;
    show: boolean;
    setShow: (x: boolean) => void;
    handleExternalCancel: () => void;
    confirmMatch: () => void;
}
export function ConfirmPatientModal({
    patientName,
    show,
    setShow,
    handleExternalCancel,
    confirmMatch,
}: ConfirmPatientModalProps) {
    return (
        <BSModal show={show} onHide={() => setShow(false)} aria-labelledby="confirm-patient-title">
            <Modal.Header closeButton>
                <Modal.Title id="confirm-patient-title" role="heading" aria-level={1}>
                    Confirm Patient
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    Please confirm whether this file should be attached to {patientName}
                    &apos;s record.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" type="button" onClick={handleExternalCancel}>
                    Cancel
                </button>
                <button className="btn btn-primary" type="button" onClick={confirmMatch}>
                    Confirm
                </button>
            </Modal.Footer>
        </BSModal>
    );
}
